import { useEffect, useState } from "react";
import "@/App.css";
import { content } from "./data/content";
import { SECTION_IDS, FILE_NAMES } from "./components/ide/files";
import { TitleBar } from "./components/ide/TitleBar";
import { ActivityBar } from "./components/ide/ActivityBar";
import { FileExplorer } from "./components/ide/FileExplorer";
import { EditorTabs } from "./components/ide/EditorTabs";
import { StatusBar } from "./components/ide/StatusBar";
import { EditorSection } from "./components/ide/EditorSection";
import { CustomCursor } from "./components/portfolio/CustomCursor";
import { HeroSection } from "./components/ide/sections/HeroSection";
import { AboutSection } from "./components/ide/sections/AboutSection";
import { ExperienceSection } from "./components/ide/sections/ExperienceSection";
import { SkillsSection } from "./components/ide/sections/SkillsSection";
import { ProjectsSection } from "./components/ide/sections/ProjectsSection";
import { EducationSection } from "./components/ide/sections/EducationSection";
import { ContactSection } from "./components/ide/sections/ContactSection";

const SECTIONS = {
  hero: HeroSection,
  about: AboutSection,
  experience: ExperienceSection,
  skills: SkillsSection,
  projects: ProjectsSection,
  education: EducationSection,
  contact: ContactSection,
};

function App() {
  const [lang, setLang] = useState("tr");
  const [theme, setTheme] = useState("dark");
  const [activeSection, setActiveSection] = useState("hero");
  const [explorerOpen, setExplorerOpen] = useState(true);
  const t = content[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    const root = document.getElementById("editor-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActiveSection(e.target.id);
        });
      },
      { root, rootMargin: "-15% 0px -65% 0px" }
    );
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div data-testid="app-root" className="h-screen flex flex-col bg-[var(--bg)] text-[var(--text)] antialiased overflow-hidden">
      <CustomCursor />
      <TitleBar />
      <div className="flex flex-1 overflow-hidden">
        <ActivityBar explorerOpen={explorerOpen} setExplorerOpen={setExplorerOpen} />
        <FileExplorer lang={lang} activeSection={activeSection} open={explorerOpen} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <EditorTabs lang={lang} activeSection={activeSection} />
          <main id="editor-scroll" className="flex-1 overflow-y-auto scroll-smooth bg-[var(--bg)]">
            {SECTION_IDS.map((id) => {
              const Section = SECTIONS[id];
              return (
                <EditorSection key={id} id={id} file={FILE_NAMES[lang][id]} testId={`${id}-section`}>
                  <Section t={t} lang={lang} />
                </EditorSection>
              );
            })}
          </main>
        </div>
      </div>
      <StatusBar lang={lang} setLang={setLang} theme={theme} setTheme={setTheme} activeSection={activeSection} />
    </div>
  );
}

export default App;
